import { useApi } from '@lib/api.ts';
import { defineStore } from 'pinia';
import { useUser } from '@/store/user';
import type { BrandDto } from '@/ApiClient.ts';
import { ref } from 'vue';

export const useBrand = defineStore('brand', () => {
  const api = useApi();
  const brand = ref<BrandDto>();

  async function loadAll() {
    brand.value = await api.brand_GetBrand(useUser().brandId);
  }

  return {
    loadAll,
    brand,
  };
});
